import { getAnalyticsPluginInfoById } from '@mimir/common/dto/analyticsModels';
import { type DynamoItemType, ItemType } from '@mimir/common/dto/itemTypes';
import type { AnalyticConfig } from '@mimir/common/dto/tenantModel';
import cloneDeep from 'lodash/cloneDeep';

export const getAnalyticConfig = (itemType: DynamoItemType, analyticConfig: AnalyticConfig): AnalyticConfig => {
  const configCopy = cloneDeep(analyticConfig);

  const analyticPlugins = configCopy.analyticPlugins;
  if (analyticPlugins) {
    for (const key in analyticPlugins) {
      const plugin = analyticPlugins[key];
      if (!plugin.enabled) continue;
      const pluginInfo = getAnalyticsPluginInfoById(plugin.id);
      if (!pluginInfo || !(pluginInfo.compatibleItemTypes ?? []).includes(itemType)) {
        plugin.enabled = false;
      }
    }
  }

  if (itemType === ItemType.AUDIO) {
    return {
      transcriptionEnabled: configCopy.transcriptionEnabled,
      transcriptionConfig: configCopy.transcriptionConfig,
      labelDetectionEnabled: false,
      textDetectionEnabled: false,
      personDetectionEnabled: false,
      celebrityDetectionEnabled: false,
      personDetectionConfig: undefined,
      textDetectionSettings: undefined,
      analyticPlugins,
    };
  } else if (itemType === ItemType.IMAGE) {
    return {
      ...configCopy,
      transcriptionEnabled: false,
      transcriptionConfig: undefined,
    };
  }

  return configCopy;
};
